export enum FetchStatusType {
    IDLE = 'idle',
    LOADING = 'loading',
    COMPLETED = 'completed',
    FAILED = 'failed',
}